import type { ActionFunctionArgs } from '@remix-run/node';
import type { SetItemBannerFromImageMutationVariables } from 'generated/graphql';
import { setItemBannerFromImage } from '~/modules/directory/api/set-item-banner-from-image.server';
import { z } from 'zod';
import * as zfd from 'zod-form-data';
import { UserErrorResponse } from '~/modules/root/graphql/responses';

const SetItemBannerInputSchema = z.object({
    libraryItemID: zfd.numeric(z.number()),
    libraryImageID: zfd.numeric(z.number()),
});

export const action = async ({ request, context }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const zfdFormData = zfd.formData(SetItemBannerInputSchema);
    const zfdResult = zfdFormData.safeParse(formData);
    if (!zfdResult.success) {
        throw new UserErrorResponse(zfdResult.error);
    }
    const variables: SetItemBannerFromImageMutationVariables = {
        LibraryItemID: zfdResult.data.libraryItemID,
        LibraryImageID: zfdResult.data.libraryImageID,
    };

    return await setItemBannerFromImage({
        ...context,
        ...variables,
    });
};

export const SET_ITEM_BANNER = '/remix-api/directory/set-item-banner';
